import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import SupplierListLayer from "../components/SupplierListLayer";

const SupplierListPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout pageTitle='Suppliers'>

        {/* SupplierListLayer */}
        <SupplierListLayer />
      </MasterLayout>
    </>
  );
};

export default SupplierListPage;
